import isNil from 'ramda/es/isNil';
import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import styled from 'styled-components';
import {Icon} from 'semantic-ui-react';
import {GreenButton, BlueButton, ButtonsGroup, LightBlueButton} from '../../components/Button/ButtonMix';
import Description from '../../components/Heading/Description';
import {BlueContainer, DefaultContainer} from '../../components/Container/ContainerMix';

const Wrapper = styled.div`
  height: calc(100vh);
  position: unset;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

const SectionTitle = styled.h1`
  color: #ffffff;
  font-size: 1.15rem !important;
  font-weight: bold !important;
  letter-spacing: 1px !important;
  line-height: 19px;
  text-align: left;
`;

const Total = styled.p`
  color: #FFFFFF;
  font-size: 72px;
  line-height: 85px;
  text-shadow: 0px 3px rgba(0,0,0,0.1) !important;
  text-align: left;
  margin-top: 2rem;
`;

const StressSection = ({router, heading, subheading, description, onDone, onNext, nextLabel, back, children}) => (
  <Wrapper>
    <BlueContainer>
      <SectionTitle>{subheading}</SectionTitle>
      <Total>{heading}</Total>
    </BlueContainer>
    <Description>{description}</Description>
    {children}
    <DefaultContainer>
      <ButtonsGroup>
        {
          back && (
            <LightBlueButton onClick={() => router.push(back)} icon labelPosition="left">
              Back
              <Icon name="arrow left"/>
            </LightBlueButton>
          )
        }
        {
          !isNil(onNext) ? (
            <BlueButton onClick={onNext} icon labelPosition="right">
              {nextLabel}
              <Icon name="arrow right"/>
            </BlueButton>
          ) : (
            <GreenButton onClick={onDone}>Okay, I'm done for now</GreenButton>
          )
        }
      </ButtonsGroup>
      {!isNil(onNext) && <GreenButton onClick={onDone}>Okay, I'm done for now</GreenButton>}
    </DefaultContainer>
  </Wrapper>
);
StressSection.propTypes = {
  router: PropTypes.object.isRequired,
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
  onNext: PropTypes.func,
  nextLabel: PropTypes.string.isRequired,
  back: PropTypes.string,
  children: PropTypes.any
};

export default withRouter(StressSection);



// WEBPACK FOOTER //
// ./src/pages/Stress/StressSection.js